export const MixingIconSvg = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2a7 7 0 0 1 7 7c0 4.5-3.5 8-7 11C8.5 17 5 13.5 5 9a7 7 0 0 1 7-7z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 22h8" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 13v9" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
